// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "h1[data-v-9f286ffa],h2[data-v-9f286ffa]{font-family:Montserrat,sans-serif;font-size:2rem;font-weight:500;margin-top:30px;color:#444;padding:10px}.btnLang[data-v-9f286ffa]{padding:0;display:flex}.btnLang li[data-v-9f286ffa]{background:#e8e9ef;cursor:pointer;padding:6px 24px;border-radius:3px;transition:all .3s ease}.btnLang li.active[data-v-9f286ffa]{background:#4cd0a3}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
